import avatarPng from '@/../img/avatar.png';
import profileBackground from '@/../img/profile-background.jpg';
import { cssVars } from '@/app/styles';
import { avatarAttrs } from '@/dashboard/components/avatar';
import { InvisibleButton } from '@/widgets/components/invisible-button';
import { Icon } from '@iconify/react';
import { Button } from 'rsuite';
import styled from 'styled-components';

export const StarIconWrapper = styled.div`
  display: flex;
  :hover {
    transform: scale(1.2);
  }
`;

export const FlexRowCenter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const FavCityIcon = styled(Icon)`
  margin-left: 5px;
  cursor: pointer;
`;

export const Background = styled.div`
  background-image: url(${profileBackground});
  background-size: contain;
  background-repeat: repeat;
  height: 100%;
  width: 100%;
`;

export const CenteredContainer = styled.div`
  margin-top: 97px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const Avatar = styled.img.attrs(({ src }) => ({
  ...avatarAttrs,
  src: src ?? avatarPng,
}))`
  display: flex;
  justify-self: center;
  max-width: 360px;
  max-height: 120px;
  border-radius: 50%;
`;

export const FormWrapper = styled.div`
  width: 360px;
  padding: 38px 30px;
  border-radius: 6px;
  box-shadow: 0 2px 8px 0 rgba(184, 195, 212, 0.4);
  background-color: rgba(255, 255, 255, 0.6);
  margin-top: 18px;
`;

export const ButtonTabsWrapper = styled.div`
  font-size: 14px;
  color: ${cssVars.color.rentalscapeBlue};
  width: ${(props) => (props.displayCitySelection ? '355px' : '255px')};
  display: flex;
  justify-content: space-between;
  margin-top: 52px;
`;

export const Label = styled.div`
  margin-bottom: 4px;
`;

export const SmallMarginLabel = styled(Label)`
  margin-top: 24px;
`;

export const BigMarginDiv = styled.div`
  margin-top: 52px;
  display: flex;
  justify-content: space-between;
`;

export const StyledButton = styled(Button)`
  &.rs-btn-default {
    background-color: ${(props) =>
      props.disabled ? '#c8d5fc' : cssVars.color.rentalscapeBlue};
    color: #ffffff;
  }
`;

export const TabItem = styled(InvisibleButton)`
  /* Reusing disabled prop to determine "active" state. Button disabled = active tab */
  color: ${(props) =>
    props.disabled ? cssVars.color.rentalscapeBlue : 'darkGray'};
  font-weight: 500;
`;

export const RequirementsError = styled.p`
  margin-top: 5px;
  color: red;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin-top: 25px;
`;

export const FixedWidthButton = styled(Button)`
  width: 150px;
`;

export const Container = styled.div`
  margin-top: 25px;
`;
